import Layout from "./layout/Layout";

const App = () => {
  return (
    <div className="news-list-content" id="news_list">
      <Layout />
    </div>
  );
};
export default App;
